import { $ } from "@/common/Axios";

export default {
  /**
   * 技能培训学生
   */
  skillStudent_edit: {
    /*
     * 编辑（上传证书或者修改成绩）
     * id id (integer query required)
     * score 成绩 (integer query )
     * cert 证书 (string query )
     */
    put: (p, c) => $.put("/api/cms/skill/skillStudent/edit", p, c),
  },
  skillStudent_assignClass: {
    /*
     * 分班
     * classId 班级id (integer query required)
     * schoolRollIds 合同id (array query required)
     */
    put: (p, c) => $.put("/api/cms/skill/skillStudent/assignClass", p, c),
  },
  skillStudent_uploadScore: {
    /*
     * 上传成绩
     * classId 班级id (integer query required)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/cms/skill/skillStudent/uploadScore", p, c),
  },
  skillStudent_list: {
    /*
     * 列表
     * classId 班级id (integer query )
     * schoolRollId 合同id (integer query )
     * name 姓名 (string query )
     */
    get: (p, c) => $.get("/api/cms/skill/skillStudent/list", p, c),
  },
  skillStudent_getIdByClassAndIdCardNo: {
    /*
     * 通过班级id和身份证查询id
     * classId 班级id (integer query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/skill/skillStudent/getIdByClassAndIdCardNo", p, c),
  },
  skillStudent_export: {
    /*
     * 导出
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/skill/skillStudent/export", p, c),
  },
  skillStudent: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/skill/skillStudent", p, c),
  },

  /**
   * 技能培训班级
   */
  skillClass_setCourseId: {
    /*
     * 设置课程id
     * classId 班级id (integer query required)
     * courseIds 课程id (array query required)
     */
    put: (p, c) => $.put("/api/cms/skill/skillClass/setCourseId", p, c),
  },
  skillClass: {
    /*
     * 添加
     * skillClass  ( query required)
     */
    post: (p, c) => $.post("/api/cms/skill/skillClass", p, c),

    /*
     * 删除
     * id 班级id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/skill/skillClass", p, c),
  },
  skillClass_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/skill/skillClass/list", p, c),
  },
  skillClass_listSimple: {
    /*
     * 简易
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/skill/skillClass/listSimple", p, c),
  },
  skillClass_getCourseId: {
    /*
     * 获取课程id（已关联的）
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/skill/skillClass/getCourseId", p, c),
  },
};
